import React, { useState, useEffect } from "react";
import styled from "styled-components";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../Users/UserDetail/CommentModal/TargetContainer";
import { ModalRow } from "../../Users/UserDetail/BlackListModal/BlackListModal";
import RadioBtn from "../../../Button/RadioBtn";
import Blank from "../../../DefaultStyles/Blank";
import dayjs from "dayjs";
import Flex from "../../../DefaultStyles/Flex";
import CalendarLineBtn from "../../../Button/CalendarLineBtn";
import { LineBoxContainer } from "../../../../pages/UserLog/UserLog";
import CalendarModal from "../../../Modal/CalendarModal";
import {
  exportJsonToExcel,
  exportJsonToExcelStyle,
} from "../../../../AdminApi/commFunc";
import { useApi } from "../../../../hooks/useApi";
import Loader from "../../../DefaultStyles/Loader";
import { useRecoilValue } from "recoil";
import { authType } from "../../../../pages/Login";
import AlertModal from "../../../Modal/AlertModal";
import { getThousandComma } from "../../../../ApiTS/ApiCommonTS";
import { toast } from "react-toastify";

interface UplusCodeDownloadModalProps extends DefaultModalCommonProps {}

export default function UplusCodeDownloadModal({
  closeEvent,
  confirmEvent,
}: UplusCodeDownloadModalProps) {
  const auth = useRecoilValue(authType);

  const [check, setCheck] = useState({
    today: true,
    select: false,
  });
  const [startDateClick, setStartDateClick] = useState(false);
  const [endDateClick, setEndDateClick] = useState(false);
  const [startDate, setStartDate] = useState("시작일 선택");
  const [endDate, setEndDate] = useState("종료일 선택");
  const [download, setDownload] = useState(false);
  const [downloadSuccessModal, setDownloadSuccessModal] = useState(false);

  const { response, loading, error } = useApi({
    method: "get",
    url:
      download && auth?.uplus
        ? `uplus2/regcode?state=1&startdate=${
            check?.select ? startDate : dayjs().format("YYYY-MM-DD")
          }&enddate=${dayjs(check?.select ? endDate : undefined)
            .add(1, "day")
            .format("YYYY-MM-DD")}`
        : undefined,
  });

  useEffect(() => {
    console.log(response);

    if (response?.status === 200) {
      setDownload(false);

      if (response?.data?.list?.length === 0) {
        toast.error("해당 기간에 다운로드 가능한 내역이 없습니다.");
      } else {
        const list: { 휴대폰번호: string; 이름: string; 기타1: string }[] = [];
        // const styleList: string[][] = [];

        response?.data?.list?.forEach(
          (
            l: { code: string; name: string; phone: string; birth: string },
            i: number
          ) => {
            list.push({
              휴대폰번호: l.phone,
              이름: l.name,
              기타1: l.code,
            });

            // styleList.push([`${i + 1}`, l?.code, l?.phone, l?.name, l?.birth]);
          }
        );

        console.log(list);

        exportJsonToExcel(
          list,
          "",
          `링키드_유플러스_결합코드발송대상자 (${dayjs().format(
            "YY년 MM월 DD일 HH시 mm분"
          )}).xlsx`
        );

        // exportJsonToExcelStyle(
        //   "링키드 결합 코드 발송 대상자 리스트",
        //   undefined,
        //   "1. 매 영업일 링키드에서 해당 데이터 다운로드 받아 고객에게 문자 발송할 것",
        //   ["Index", "Code", "Phone", "Name", "Birth"],
        //   "링키드_유플러스_결합코드발송대상자리스트다운로드",
        //   "Message List",
        //   styleList
        // );

        setDownloadSuccessModal(true);
      }
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(
        error?.data ??
          "결합 코드 발송 대상자 리스트를 가져오는 데에 실패하였습니다."
      );
    }
  }, [error]);

  return (
    <>
      <DefaultModalLayout
        modalTitle="결합 코드 발송 대상자 다운로드"
        closeEvent={() => closeEvent()}
        confirmEvent={() => {
          setDownload(true);
        }}
        isMediumModal={true}
        confirmBtnText="다운로드"
      >
        <ModalLabel>다운로드 기간 선택</ModalLabel>

        <Blank blankHeight={20} />

        <ModalRow>
          <ModalLabelColumn>
            <RadioBtn
              label="오늘"
              check={check.today}
              noTooltip={true}
              clickEvent={() => {
                setCheck({
                  today: !check.today,
                  select: false,
                });
              }}
            />
          </ModalLabelColumn>

          <ModalValueColumn>
            <DefaultBox>{dayjs().format("YYYY-MM-DD")}</DefaultBox>
          </ModalValueColumn>
        </ModalRow>

        <ModalRow style={{ alignItems: "flex-start" }}>
          <ModalLabelColumn>
            <RadioBtn
              label="기간 선택"
              check={check.select}
              noTooltip={true}
              clickEvent={() => {
                setCheck({
                  select: !check.select,
                  today: false,
                });
              }}
              sHeight={38}
            />
          </ModalLabelColumn>

          <ModalValueColumn>
            <Flex gapSize={4}>
              <LineBoxContainer>
                <CalendarLineBtn
                  onClickEvent={() => setStartDateClick(true)}
                  value={startDate}
                  initValue={"시작일 선택"}
                  disabled={!check?.select}
                />

                {startDateClick && (
                  <CalendarModal
                    closeEvent={() => setStartDateClick(false)}
                    changeEvent={(date: string) => setStartDate(date)}
                    isFutureDisable={true}
                  />
                )}
              </LineBoxContainer>

              <>{" ~ "}</>

              <LineBoxContainer>
                <CalendarLineBtn
                  onClickEvent={() => setEndDateClick(true)}
                  value={endDate}
                  initValue={"종료일 선택"}
                  disabled={startDate === "시작일 선택" || !check?.select}
                />

                {endDateClick && (
                  <CalendarModal
                    closeEvent={() => setEndDateClick(false)}
                    changeEvent={(date: string) => setEndDate(date)}
                    dateValue={startDate}
                    isAfter={{ value: 7, unit: "d" }}
                  />
                )}
              </LineBoxContainer>
            </Flex>

            <Blank blankHeight={4} />

            <Desc>기간 시작일로부터 최대 7일까지 선택 가능</Desc>
          </ModalValueColumn>
        </ModalRow>
      </DefaultModalLayout>

      {loading && <Loader />}

      {downloadSuccessModal && (
        <AlertModal
          title={`결합 코드 발송 대상자 다운로드 완료\n즉시 고객에게 문자를 보내주세요.`}
          desc={`${getThousandComma(response?.data?.list?.length)}건 다운로드`}
          btnColor="mint"
          confirmText="확인"
          confirmEvent={() => setDownloadSuccessModal(false)}
          customCancelBtn={<></>}
        />
      )}
    </>
  );
}

const ModalLabelColumn = styled.div`
  width: 100px;
`;

const ModalValueColumn = styled.div`
  width: calc(100% - 100px);
`;

export const DefaultBox = styled.div`
  width: 100%;
  padding: 10px 16px;
  border-radius: 3px;
  background-color: #f6f6f8;

  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: #808080;
`;

const Desc = styled.div`
  font-size: 13px;
  line-height: 19.5px;
  text-align: left;
  color: #808080;
`;
